import { Controller } from "@hotwired/stimulus"

// App-styled gating for stepper forms: fields marked data-step-required get
// the form builder's error treatment (red-bordered input + message under the
// field) when Next is pressed while they're blank, instead of the native
// browser validity bubble. Listens for the rails-blocks stepper's cancelable
// stepper:validate event; preventDefault blocks the advance.
export default class extends Controller {
  check(event) {
    const steps = this.element.querySelectorAll("[data-rails-blocks--stepper-target='step']")
    const step = steps[event.detail.step]
    if (!step) return

    let valid = true
    let firstInvalid = null
    step.querySelectorAll("[data-step-required]").forEach((input) => {
      this.clearError(input)
      if (input.value.trim() === "") {
        valid = false
        firstInvalid ||= input
        this.showError(input, input.dataset.stepRequired || "can't be blank")
      }
    })

    if (!valid) {
      event.preventDefault()
      firstInvalid?.focus()
    }
  }

  showError(input, message) {
    input.classList.add("error")
    const error = document.createElement("p")
    error.className = "mt-1 text-sm text-red-600"
    error.setAttribute("data-step-validation-error", "")
    error.textContent = message
    input.insertAdjacentElement("afterend", error)
    input.addEventListener("input", () => this.clearError(input), { once: true })
  }

  clearError(input) {
    input.classList.remove("error")
    const next = input.nextElementSibling
    if (next?.hasAttribute("data-step-validation-error")) next.remove()
  }
}
